require("navigation");
require("common");
require("components/parallax-content");

// ********  carousel
$('.carousel').slick({
  infinite: false,
  speed: 800,
  slidesToShow: 3,
  slidesToScroll: 1,
  swipe: true,
  responsive: [
  {
    breakpoint: 992,
    settings: {
      slidesToShow: 2
    }
  },
  {
    breakpoint: 600,
    settings: {
      slidesToShow: 1
    }
  }
  ]
});

function wdthOfContainerFixe() {
  $('.lot-container-fixed').css("width", "")
  $('.lot-container-fixed').css("width", $('.lot-container-fixed').width()+"px")
  $('.tofix .vc_column-inner .wpb_wrapper:not(.fixed) ').css("width", "")
  $('.tofix .vc_column-inner .wpb_wrapper:not(.fixed) ').css("width", $('.tofix .vc_column-inner .wpb_wrapper').width()+"px")
}
var boxH = '';
if ($('.tofix').length) {
  console.log($(this).prev());
  $('.tofix').prev().removeClass('vc_col-sm-8');
  $('.tofix').removeClass('vc_col-sm-4');
}
$(window).scroll(function (e) {
  if (window.innerWidth > 890) {
    if ($('.lot-wrapper-fixed').length) {
      if ($(window).scrollTop() > $('.lot-wrapper-fixed').offset().top) {
        $('.lot-container-fixed').addClass('fixed');
      }else{
        $('.lot-container-fixed').removeClass('fixed');
      }
      if($(window).scrollTop() > $('.lot-wrapper-fixed').offset().top && $(window).scrollTop()+$('.lot-container-fixed').height() > $('.lot-wrapper-fixed').offset().top+$('.lot-wrapper').height()) {
        $('.lot-wrapper-fixed').css('height', $('.lot-wrapper').height()+'px')
        $('.lot-container-fixed').addClass('fixed-bottom');
      }else{
        $('.lot-wrapper-fixed').css('height', '')
        $('.lot-container-fixed').removeClass('fixed-bottom');
      }
    }
  }

  if (window.innerWidth > 890) {

    if ($('.residence-wrapper-fixed').length) {
      if ($(window).scrollTop() > $('.residence-wrapper-fixed').offset().top) {
        $('.residence-container-fixed').addClass('fixed');
      }else{
        $('.residence-container-fixed').removeClass('fixed');
      }
      if($(window).scrollTop() > $('.residence-wrapper-fixed').offset().top &&
        $(window).scrollTop()+$('.residence-container-fixed').height()> $('.residence-wrapper').offset().top+$('.residence-wrapper').height()) {
        $('.residence-wrapper-fixed').css('height', $('.residence-wrapper').height()+'px')
      $('.residence-container-fixed').addClass('fixed-bottom');
    }else{
      $('.residence-wrapper-fixed').css('height', '')
      $('.residence-container-fixed').removeClass('fixed-bottom');
    }
  }
}

if (window.innerWidth >= 1200) {
  if ($('.tofix').length) {
    $(this).prev('.wpb_column').removeClass('vc_col-sm-8');
    $('.tofix').css('height',$('.tofix').parent().outerHeight());
    $('.tofix .vc_column-inner ').css('height',$('.tofix').parent().outerHeight());
    if ($(window).scrollTop() > $('.tofix').offset().top) {
      $('.tofix .vc_column-inner .wpb_wrapper ').addClass('fixed');
      $('.tofix .vc_column-inner .wpb_wrapper ').css('top',$('header').outerHeight());
    }else{
      $('.tofix .vc_column-inner .wpb_wrapper ').removeClass('fixed');
    }

    if (boxH == '') {
      console.log('is null');
      boxH = $('.tofix .wpb_wrapper').outerHeight();
    }

    console.log('parent:'+$('.tofix').parent().offset().top + $('.tofix').parent().outerHeight());
    console.log(boxH);
    if($(window).scrollTop() + boxH > $('.tofix').parent().offset().top + $('.tofix').parent().outerHeight()) {
        // $('.tofix').css('height', $('.vc_row-has-fill').height()+'px')
        $('.tofix .vc_column-inner .wpb_wrapper').css('top','auto');
        $('.tofix .vc_column-inner .wpb_wrapper').addClass('fixed-bottom');
      }else{
        $('.tofix .vc_column-inner .wpb_wrapper').removeClass('fixed-bottom');
      }
    }

  }

})

function residence_description_short() {
  if ($('.residence-description--short').length) {
    var H = $('.residence-description--short').outerHeight();
    $('.residence-description--short').css('margin-top', (-H/3)*2+"px");
  }
}

function lotSliderFlexslider() {
  if ($('.lot-slider #slider .flex-viewport').length && $('.lot-slider #slider.flexslider').length) {
    var width = $('.lot-slider #slider.flexslider').width();
    var baseW = 900;
    var baseH = 500;

    //console.log(width/((baseH*width)/baseW), 900/500)

    $('.lot-slider #slider .flex-viewport').css("height", (baseH*width)/baseW+"px")
  }
}

function residenceSliderFlexslider() {
  if ($('.residence-slider #slider .flex-viewport').length && $('.residence-slider #slider.flexslider').length) {
    var width = $('.residence-slider #slider.flexslider').width();
    var baseW = 1495;
    var baseH = 700;

    //console.log(width/((baseH*width)/baseW), 1495/700)

    $('.residence-slider #slider .flex-viewport').css("height", (baseH*width)/baseW+"px")
  }
}

$(window).load(function () {
  wdthOfContainerFixe();

  if ($('.residence-container').outerHeight() < $('.residence-container-fixed').outerHeight()) {
    $('.residence-container').css('height', $('.residence-container-fixed').outerHeight()+'px')
  }

  /*Slider ratio image*/
  lotSliderFlexslider();
  residenceSliderFlexslider();

  /*description short residence*/
  residence_description_short();


})

$(window).resize(function () {
  wdthOfContainerFixe()
  if ($('.residence-container').outerHeight() < $('.residence-container-fixed').outerHeight()) {
    $('.residence-container').css('height', $('.residence-container-fixed').outerHeight()+'px')
  } else{
    $('.residence-container').css('height', '')
  }
  /*Slider ratio image*/
  lotSliderFlexslider();
  residenceSliderFlexslider();

  /*description short residence*/
  residence_description_short();
})

